import React, { useState } from "react";
import CustomModal from "../CustomModal/CustomModal";
import EditIndentModalBody from "./EditIndentModalBody";
import { SectionInterface } from "../../../store/types/store";
import { useAlerts } from "../../../hooks/useAlerts";
import { useStoreSystem } from "../../../store";
import { useShelvingStore } from "../../../store/useShelvingStore";

export type SectionWidth = 600 | 800 | number;
type EditSectionModalType = {
    editSection: SectionInterface
}

const EditIndentModal: React.FunctionComponent<EditSectionModalType> = ({ editSection }) => {
    const { sectionEditModal, setSectionEditModal } = useStoreSystem((state) => ({
        sectionEditModal: state.sectionEditModal,
        setSectionEditModal: state.setSectionEditModal
    }));
    const { getCurrentShelf, updateSection } = useShelvingStore((state) => ({
        getCurrentShelf: state.getCurrentShelving,
        updateSection: state.updateSection,
    }));
    const [activeWidth, setActiveWidth] = useState(editSection.width);

    const currentShelf = getCurrentShelf();
    const { addReadyAlert } = useAlerts();
    const sections = currentShelf.sections;

    function onCloseEditSectionModal() {
        const prevSectionIndex = sections.findIndex((section) => editSection.id === section.id) - 1;
        const prevSection = prevSectionIndex === -1 ? { ...editSection } : sections[prevSectionIndex];
        if (prevSection?.items?.find(item => item.width > prevSection?.width) && activeWidth !== editSection.width) {
            addReadyAlert(
                `Возможная ширина отступа ${editSection.width} мм с учетом наполнения предыдущей секции.
                    Пожалуйста, удалите наполнение из предыдущей секции прежде, чем изменять ширину`,
                "error",
                5000
            );
            return
        }
        updateSection({ ...editSection, width: activeWidth });
        closeModal();
    }

    const closeModal = () => {
        setSectionEditModal({ isOpen: false, section: undefined });
    }

    return (
        <CustomModal
            isOpenModal={sectionEditModal.isOpen && sectionEditModal?.type === 'indent'}
            onCloseModalCallback={onCloseEditSectionModal}
        >
            <EditIndentModalBody
                setActiveWidth={setActiveWidth}
                activeWidth={activeWidth}
                currentSection={editSection}
                closeModal={closeModal}
                currentShelf={currentShelf}
            />
        </CustomModal>
    );
};

export default EditIndentModal;
